import loadable from '@loadable/component';

export default loadable(() =>
  import(
    /* webpackChunkName: "ag-grid" */
    /* webpackPrefetch: true */
    './AgGrid'
  ),
);
